/**
 * Bhulmann — Página de bloqueio de aniversário
 * Web component do countdown regressivo até a reabertura (ADR-0009).
 *
 * Conta até a próxima ocorrência da hora `data-reopen-hour` (0 = meia-noite),
 * no fuso do navegador do visitante (loja Brasil-only → America/Sao_Paulo).
 * Ao zerar, troca o relógio por um CTA "Entrar na loja" (sem auto-reload-loop).
 *
 * Único JS da página. Tudo o mais (unlock de senha, e-mail) funciona sem JS.
 */
(function () {
  'use strict';

  var SECOND = 1000;

  function pad(n) {
    return String(n).padStart(2, '0');
  }

  class BhulmannCountdown extends HTMLElement {
    connectedCallback() {
      this.reopenHour = parseInt(this.getAttribute('data-reopen-hour') || '0', 10);
      if (isNaN(this.reopenHour) || this.reopenHour < 0 || this.reopenHour > 23) {
        this.reopenHour = 0;
      }

      this.hh = this.querySelector('[data-cd-hh]');
      this.mm = this.querySelector('[data-cd-mm]');
      this.ss = this.querySelector('[data-cd-ss]');
      this.grid = this.querySelector('[data-cd-grid]');
      this.openState = this.querySelector('[data-cd-open]');

      this.tick();
      this.timer = setInterval(this.tick.bind(this), SECOND);
    }

    disconnectedCallback() {
      if (this.timer) clearInterval(this.timer);
    }

    /** Timestamp da próxima ocorrência de reopenHour:00:00. */
    getTarget() {
      var d = new Date();
      var t = new Date(d.getFullYear(), d.getMonth(), d.getDate(), this.reopenHour, 0, 0, 0);
      if (t.getTime() <= d.getTime()) {
        t.setDate(t.getDate() + 1);
      }
      return t.getTime();
    }

    tick() {
      var diff = Math.max(0, this.getTarget() - Date.now());

      if (diff <= 0) {
        this.reachZero();
        return;
      }

      var totalSec = Math.floor(diff / SECOND);
      if (this.hh) this.hh.textContent = pad(Math.floor(totalSec / 3600));
      if (this.mm) this.mm.textContent = pad(Math.floor((totalSec % 3600) / 60));
      if (this.ss) this.ss.textContent = pad(totalSec % 60);
    }

    /** Estado de reabertura: troca relógio por CTA. Sem reload automático. */
    reachZero() {
      if (this._done) return;
      this._done = true;
      if (this.timer) clearInterval(this.timer);
      if (this.grid) this.grid.hidden = true;
      if (this.openState) this.openState.hidden = false;
    }
  }

  if (!customElements.get('bhulmann-countdown')) {
    customElements.define('bhulmann-countdown', BhulmannCountdown);
  }
})();
